import { render, staticRenderFns } from "./fullsizeCover.vue?vue&type=template&id=e3212f06&scoped=true&"
import script from "./fullsizeCover.vue?vue&type=script&lang=js&"
export * from "./fullsizeCover.vue?vue&type=script&lang=js&"
import style0 from "./fullsizeCover.vue?vue&type=style&index=0&id=e3212f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3212f06",
  null
  
)

export default component.exports